<template>
  <fts-client-modal
    width="1080px"
    :title="fileName"
    append-content-class="document-modal__body"
    append-container-class="document-viewer-container"
    class="fts-document-modal"
    @closed="reset"
    ref="ftsClientModal"
  >
    <!-- header:icon -->
    <font-awesome-icon slot="icon" :icon="['fas', 'print']" fixed-width />
    <!-- body -->
    <template #body>
      <!-- loading indicator -->
      <div class="loading-indicator" v-if="loading">
        <fts-spinner show />
        <div class="loading-indicator-label">Getting document...</div>
      </div>
      <!-- pdf -->
      <vue-pdf-app
        theme="light"
        :config="config"
        :file-name="fileName"
        :pdf="previewDocument"
        @open="openHandler"
        @after-created="openHandler"
      >
        <template #toolbar-right-prepend>
          <button
            type="button"
            class="toolbarButton vue-pdf-app-icon"
            :disabled="loading"
            @click="loadDocument"
          >
            <font-awesome-icon :icon="['fas', 'sync-alt']" size="lg" />
          </button>
        </template>
      </vue-pdf-app>
    </template>
  </fts-client-modal>
</template>

<script>
import VuePdfApp from "vue-pdf-app";

import { classificationStore } from "../store/classificationStore";
import webAppConfig from "../commons/webApp.config";

import FTSClientModal from "./FTSClientModal";
import FTSBtn from "./FTSBtn";
import FTSSpinner from "./FTSSpinner";
import { clientStore } from "../store/clientStore";

export default {
  data: () => ({
    pdfApplication: null,
    template: null,
    // idConfig: { print: "printId", download: "downloadId" },
    configTest: {
      sidebar: false,
      toolbar: false,
      secondaryToolbar: false
    },
    config: {
      sidebar: false,
      toolbar: {
        toolbarViewerLeft: {
          findbar: false,
          previous: false,
          next: false
        },
        toolbarViewerRight: {
          presentationMode: false,
          openFile: false,
          viewBookmark: false
        }
      },
      secondaryToolbar: false
    },
    fileName: "preparing...",
    previewDocument: null,
    loading: false
  }),
  components: {
    VuePdfApp,
    "fts-client-modal": FTSClientModal,
    "fts-btn": FTSBtn,
    "fts-spinner": FTSSpinner
  },
  computed: {
    workspaceId() {
      return clientStore.getters.workspaceId;
    }
  },
  methods: {
    async show(template) {
      this.template = template;
      this.$refs.ftsClientModal.show();
      await this.loadDocument();
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    async loadDocument() {
      let vm = this;
      let template = this.template;
      this.previewDocument = null;
      this.loading = true;

      /* base 64 to array buffer */
      function _base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
          bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
      }

      if (
        template.url &&
        template.parameters &&
        !template.parameters.template
      ) {
        try {
          await new Promise(async (resolve, reject) => {
            var xhr = new XMLHttpRequest();
            xhr.open(
              "GET",
              webAppConfig.baseURL
                ? webAppConfig.baseURL + template.url
                : template.url,
              true
            );
            const token = JSON.parse(
              localStorage.getItem("ls.authorizationData")
            )["access_token"];
            xhr.setRequestHeader(
              "Content-type",
              "application/json;charset=UTF-8"
            );
            xhr.setRequestHeader("authorization", "bearer " + token);
            xhr.setRequestHeader("wsId", this.workspaceId);
            xhr.responseType = "arraybuffer";
            // onload
            xhr.onload = async function() {
              if (this.status === 200) {
                var filename = "";
                // to-do check (local development error: Refused to get unsafe header "Content-Disposition")
                var disposition = xhr.getResponseHeader("Content-Disposition");
                if (disposition) {
                  var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                  var matches = filenameRegex.exec(disposition);
                  if (matches != null && matches[1])
                    filename = matches[1].replace(/['"]/g, "");
                  vm.fileName = decodeURIComponent(filename);
                }
                var type = xhr.getResponseHeader("Content-Type");
                var blob;
                if (typeof File === "function") {
                  try {
                    blob = new File([this.response], filename, { type: type });
                  } catch (err) {
                    console.error(err);
                  }
                }
                if (typeof blob === "undefined") {
                  blob = new Blob([this.response], { type: type });
                }
                if (typeof window.navigator.msSaveBlob !== "undefined") {
                  // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                  window.navigator.msSaveBlob(blob, filename);
                } else {
                  await blob.arrayBuffer().then(buffer => {
                    vm.previewDocument = buffer;
                  });
                }
                resolve(true);
              } else {
                reject();
              }
            };
            // onerror
            xhr.onerror = function() {
              reject();
            };
            // send
            xhr.send();
            // var formData = new FormData();
            // Object.keys(template.parameters).forEach(key => formData.append(key, object[key]));
            // var postData = JSON.stringify(template.parameters);
            // xhr.send(postData);
          });
        } catch (err) {
          console.error("Document:XMLHttpRequest", err);
        }
      } else {
        try {
          let res = await classificationStore.dispatch(
            "loadDocument",
            template.parameters
          );
          this.previewDocument = _base64ToArrayBuffer(res.data.bytes);
          this.fileName = decodeURIComponent(res.data.filename);
        } catch (err) {
          console.error("Document:LoadDocument", err);
        }
      }
      this.loading = false;
    },
    openHandler(pdfApplication) {
      this.pdfApplication = pdfApplication;
      try {
        pdfApplication.pdfViewer.container.classList.add("fts-scrollbar");
      } catch (err) {
        console.warn("[DOMException]:OpenHandler", err);
      }
    }
  }
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-document-modal {
  .document-viewer-container {
    height: 100%;
    .document-modal__body {
      position: relative;
      padding: 0;
    }
  }
  .pdf-app .pdfViewer .page {
    box-sizing: content-box;
    border-image: none;
  }
  .loading-indicator {
    @include absolute-center-middle;
    z-index: 999;
    .loading-indicator-label {
      margin-top: 1.5rem;
    }
  }
}
</style>